import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";

const detailToText = (d) => {
  if (!d) return "Sign in failed";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d.msg || String(d);
};

export const EmailLoginForm = ({ onSuccess }) => {
  const { setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const r = await api.post("/auth/login", { email, password });
      setUser(r.data.user);
      toast.success(`Welcome back, ${r.data.user?.name || "there"}`);
      onSuccess?.(r.data.user);
    } catch (err) {
      setError(detailToText(err.response?.data?.detail) || err.message);
    }
    setBusy(false);
  };

  return (
    <form onSubmit={submit} className="text-left space-y-3" data-testid="email-login-form">
      <div>
        <label className="text-xs font-black uppercase tracking-widest text-slate-500">Email</label>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input"
          autoComplete="email" className="mt-1 w-full h-11 rounded-lg border border-slate-300 px-3 focus:outline-none focus:ring-2 focus:ring-brand-navy" />
      </div>
      <div>
        <label className="text-xs font-black uppercase tracking-widest text-slate-500">Password</label>
        <div className="relative mt-1">
          <input type={showPw ? "text" : "password"} required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input"
            autoComplete="current-password" className="w-full h-11 rounded-lg border border-slate-300 pl-3 pr-11 focus:outline-none focus:ring-2 focus:ring-brand-navy" />
          <button type="button" onClick={() => setShowPw((v) => !v)} data-testid="login-password-toggle"
            aria-label={showPw ? "Hide password" : "Show password"}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-slate-400 hover:text-brand-navy">
            {showPw ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </button>
        </div>
      </div>
      {error && <div className="text-sm font-bold text-brand-red" data-testid="login-error">{error}</div>}
      <button type="submit" disabled={busy} data-testid="login-submit-btn"
        className="w-full h-12 rounded-full bg-brand-red text-white font-bold disabled:opacity-60 transition-colors hover:bg-red-700">
        {busy ? "Signing in..." : "Sign in"}
      </button>
    </form>
  );
};
